import { getListBrowserStore } from '@ts-private/list-browser';

const userStore = getListBrowserStore({
  filterDefinitions: [
    {
      name: 'name',
      caption: 'Users.Name',
      type: 'text'
    },
    {
      name: 'remark',
      caption: 'Users.Remark',
      type: 'text'
    }
  ],
  orderByFields: [
    {
      caption: 'Users.Name',
      value: 'Name'
    }
  ],
  pager: {
    orderBy: 'Name',
    direction: 'asc'
  }
});

export default userStore;
